var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-recommendations"},[_c('products-grid',{attrs:{"loading":_vm.loading,"records":_vm.records,"placeholders":10,"trackProps":{zone: 'RECOMMENDED_PRODUCTS', recommendation_model: _vm.recommendationModel}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }